module.exports = __webpack_public_path__ + "static/media/svg-2.adb844ce.svg";